import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/operational-area', { params }),
  create: params => axios.post('/api/v1/avg/operational-area', params),
  update: params => axios.put(`/api/v1/avg/operational-area/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/operational-area', { params }),
  getById: id => axios.get(`/api/v1/avg/operational-area/${id}`)
};
